export const Empty = () => {
  return (
    <section data-testid="main-content" className="w-fit mx-auto text-center flex items-center min-h-[80vh]">
      <div>
        <svg
          className="mx-auto mb-3"
          xmlns="http://www.w3.org/2000/svg"
          width="78"
          height="75"
          viewBox="0 0 78 75"
          fill="none"
        >
          <path
            d="M0 67.5C0 69.4891 0.821783 71.3968 2.28457 72.8033C3.74735 74.2098 5.73131 75 7.8 75H19.5V67.5H7.8V56.25H0V67.5ZM78 67.5V56.25H70.2V67.5H58.5V75H70.2C72.2687 75 74.2526 74.2098 75.7154 72.8033C77.1782 71.3968 78 69.4891 78 67.5ZM70.2 7.5V18.75H78V7.5C78 5.51088 77.1782 3.60323 75.7154 2.1967C74.2526 0.790176 72.2687 0 70.2 0H58.5V7.5H70.2ZM0 7.5V18.75H7.8V7.5H19.5V0H7.8C5.73131 0 3.74735 0.790176 2.28457 2.1967C0.821783 3.60323 0 5.51088 0 7.5ZM31.2 75H46.8V67.5H31.2V75ZM31.2 7.5H46.8V0H31.2V7.5ZM70.2 45H78V30H70.2V45ZM0 45H7.8V30H0V45Z"
            fill="#828282"
          />
        </svg>
        <div className="font-medium">Pilih task pada bagian sebelah kiri</div>
      </div>
    </section>
  )
}
